// Adicione esta função de formatação
export const formatCpfCnpj = (value) => {
  const cleaned = value.replace(/\D/g, '');
  
  if (cleaned.length <= 11) {
    // Formata como CPF: 999.999.999-99
    return cleaned
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1');
  } else {
    // Formata como CNPJ: 99.999.999/9999-99
    return cleaned
      .replace(/(\d{2})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1/$2')
      .replace(/(\d{4})(\d)/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1');
  }
};

// Funções auxiliares que precisam ser exportadas também
export const isValidCPF = (cpf) => {
  cpf = cpf.replace(/\D/g, '');
  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

  let sum = 0;
  for (let i = 0; i < 9; i++) sum += cpf[i] * (10 - i);
  let d1 = (sum * 10) % 11;
  if (d1 === 10) d1 = 0;
  if (d1 != cpf[9]) return false;

  sum = 0;
  for (let i = 0; i < 10; i++) sum += cpf[i] * (11 - i);
  let d2 = (sum * 10) % 11;
  if (d2 === 10) d2 = 0;
  return d2 == cpf[10];
};

export const isValidCNPJ = (cnpj) => {
  cnpj = cnpj.replace(/\D/g, '');
  if (cnpj.length !== 14) return false;

  const calc = (x) => {
    let n = 0;
    let pos = x - 7;
    for (let i = x; i >= 1; i--) {
      n += cnpj[x - i] * pos--;
      if (pos < 2) pos = 9;
    }
    return n % 11 < 2 ? 0 : 11 - (n % 11);
  };

  return calc(12) == cnpj[12] && calc(13) == cnpj[13];
};

// Mantenha as funções existentes
export const validateCpfCnpj = (value) => {
  // Remove caracteres não numéricos
  const cleaned = value.replace(/[^\d]/g, '');
  
  if (cleaned.length === 11) {
    // Validação de CPF
    return isValidCPF(cleaned);
  } else if (cleaned.length === 14) {
    // Validação de CNPJ
    return isValidCNPJ(cleaned);
  }
  return false;
};

// Adicione também funções úteis
export const getDocumentType = (value) => {
  const cleaned = value.replace(/\D/g, '');
  if (cleaned.length === 11) return 'CPF';
  if (cleaned.length === 14) return 'CNPJ';
  return null;
};

export const cleanDocument = (value) => {
  return value.replace(/\D/g, '');
};